import React from "react";
import PropTypes from "prop-types";
import Hgroup from "public-components/Hgroup";
import Container from "public-components/Container";
import styles from "./MetaGridSection.module.scss";

import ThumbIcon from "./icons/thumb.svg";
import UsersIcon from "./icons/users.svg";
import GlobalIcon from "./icons/global.svg";

import CircleBG from "assets/background/circle.svg";

const iconsEnum = {
  thumb: ThumbIcon,
  users: UsersIcon,
  global: GlobalIcon
};

const MetaGridSection = ({ data }) => {
  return (
    <section className={styles.metaSection}>
      <CircleBG className={styles.metaSection__circle} />
      <Container>
        <Hgroup className={styles.metaSection__hgroup} heading={data.headingH2} />
        <div className={styles.metaSection__row}>
          {data.metaDataList.map(i => (
            <div className={styles.metaSection__item} key={i.id}>
              <div className={styles.meta}>
                <div className={styles.meta__icon}>{React.createElement(iconsEnum[i.icon])}</div>
                <h3 className={styles.meta__heading}>{i.number}</h3>
                <div className={styles.meta__text} dangerouslySetInnerHTML={{ __html: i.text }} />
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

MetaGridSection.propTypes = {
  data: PropTypes.shape({
    headingH2: PropTypes.string.isRequired,
    metaDataList: PropTypes.arrayOf(PropTypes.object)
  }).isRequired
};

export default MetaGridSection;
